var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.611 13.49 0 7.5 6.389 1.51 0 0 1.611 5.99 8 0 14.389 1.51 16 7.5 9.611 13.49 16 15 14.389 9.01 8 15 1.611Z"
  })));
};
export default SvgClose;